exports.components = {
  "component---src-asciidoc-template-tsx": () => import("./../../../src/asciidoc/template.tsx" /* webpackChunkName: "component---src-asciidoc-template-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */)
}

